import React from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { addRegistration, removeRegistration } from '../../store/registrations/registrations'
import { EVENTS } from '../../routes'
import { IEvent } from '../../store/events/interfaces'
import { addToast } from '../../store/misc/misc'
import { ToastType } from '../../store/misc/interfaces'
import { Col, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { checkRegIntegrity } from '../../functions/events/EventIntegrity'
import { IRegistration } from '../../store/registrations/interfaces'
import { useAppSelector } from '../../hooks'

export const EventActions = (props: {
  event: IEvent
  //hasRegistration: boolean
}) => {
  const { list: registrations } = useAppSelector(
    (state) => state.registrations,
  )
  const dispatch = useDispatch()
  const { data: program } = useAppSelector((state) => state.program)
  const { event } = props
  const { loadedViaCode } = useAppSelector((state) => state.misc)

  const hasRegistration = registrations.some(
    (reg: IRegistration) => reg.event.event_id === event.event_id,
  )

  const { originalRegistrationIds } = useAppSelector(
    (state) => state.participant.data,
  )
  const isOriginalReg = originalRegistrationIds.includes(event?.event_id)

  let currentDate = new Date()
  let eventDate = new Date(event.first_registration_date)

  const isOver: boolean =
    Boolean(props.event.end) && new Date(props.event.end) < new Date()

  const isRegistrationDateChangeAllowed = program.is_organizer_registration_date_change_allowed && eventDate > currentDate;

  const isExternal = event.has_external_registration;

  const isEventFull = (event.max_participants === 0 && event.max_participants != null) || (event.registration_statistics.registration_amount_yes >= event.max_participants && event.registration_statistics.is_waiting_list_full)

  const navigate = useNavigate()
  return (
    <Col md={12} className='pl-0'>
      {program.is_participant_registration_allowed ?
          <button
            className={
              'btn mb-2 w-100 ' + (hasRegistration ? 'btn-success' : 'btn-info')
            }
            disabled={
              props.event.has_external_registration ||
              props.event.canceled ||
              (loadedViaCode && hasRegistration && isOriginalReg) ||
              isOver || isRegistrationDateChangeAllowed ||
              isEventFull
            }
            onClick={() => {
              if (
                registrations.some(reg => reg.event.event_id === event.event_id)
              ) {
                dispatch(removeRegistration(event.event_id))
              } else {
                const issueToast = checkRegIntegrity(
                  event,
                  registrations,
                  program,
                )
                if (issueToast) {
                  dispatch(addToast(issueToast))
                  if (issueToast.type === ToastType.Warning) {
                    dispatch(addRegistration(event))
                  }
                } else {
                  dispatch(addRegistration(event))
                }
              }
            }}
          >
            {
              isEventFull ? 'Voll' :
              isOver ? 'Vorbei' :
              isRegistrationDateChangeAllowed ? "Ab dem " + eventDate.toLocaleDateString('de-DE') :
              isExternal ?
                  <>
                  <FontAwesomeIcon icon='external-link-square-alt' role='presentation' />
                  &nbsp;Externe Anmeldung
                  </> :
              hasRegistration ? 'Abwählen' :
              <>
                <FontAwesomeIcon icon="hand-point-up" />
                &nbsp;Auswählen
              </>
            }
          </button>
      : ""}
      {isExternal ? (
          <button
            className='btn btn-outline-dark w-100 h-100 d-flex align-items-center justify-content-center'
            onClick={() => navigate(`${EVENTS.path}/${event.event_id}`)}
          >
            Mehr Erfahren
          </button>
        ) : (
          <button
            className='btn btn-outline-dark w-100 h-100 d-flex align-items-center justify-content-center'
            onClick={() => navigate(`${EVENTS.path}/${event.event_id}`)}
          >
            <FontAwesomeIcon icon='info-circle' role='presentation' />
            &nbsp;Details
          </button>
        )}
    </Col>
  )
}
